import React from 'react';
import {classNames} from 'utils';

const PAY_DURATION_SELECTIONS = [
  {text: 'Monthly', payDuration: 'monthly'},
  {text: 'Yearly', payDuration: 'yearly'},
] as const;

export type PayDurationType = 'monthly' | 'yearly';

interface IPlansTogglePayDurationProps {
  payDuration: PayDurationType;
  setPayDuration: (payDuration: PayDurationType) => void;
}

const PlansTogglePayDuration = ({payDuration, setPayDuration}: IPlansTogglePayDurationProps) => {
  return (
    <div className="flex justify-center">
      <div className="flex items-center gap-x-1 rounded-full bg-white dark:bg-slate-800 text-center text-xs sm:text-sm font-semibold border border-slate-300 dark:border-slate-700">
        {PAY_DURATION_SELECTIONS.map(selection => {
          return (
            <button
              key={selection.payDuration}
              type="button"
              className={classNames('group relative rounded-full px-6 py-2 cursor-pointer', selection.payDuration === payDuration && 'bg-primary')}
              onClick={() => setPayDuration(selection.payDuration)}>
              <span className={classNames(selection.payDuration === payDuration ? 'text-white' : 'text-slate-800 dark:text-white')}>
                {selection.text}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(PlansTogglePayDuration);
